import * as actionTypes from './actionTypes';
import { leadService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchLeadRequest = () => ({
  type: actionTypes.FETCH_LEAD_REQUEST
});

const fetchLeadFailure = () => ({
  type: actionTypes.FETCH_LEAD_FAILURE
});

const fetchLeadSuccess = (data) => ({
  type: actionTypes.FETCH_LEAD_SUCCESS,
  data
});

export const clearLeadData = () => ({
  type: actionTypes.CLEAR_LEAD_DATA
});

export const fetchLead = (json) => {
  return async dispatch => {
    dispatch(fetchLeadRequest());
    try {
      const data = await leadService.post(json);
      if (data.error) {
        dispatch(actionsModalError.openModalError());
      } else {
        dispatch(fetchLeadSuccess(data.data[0]));
      }
    } catch (error) {
      console.log(`Error fetch Lead action: ${error}`)
      dispatch(actionsModalError.openModalError());
      dispatch(fetchLeadFailure());
    }
  }
};

export const fetchLeadHome = (json) => {
  return async dispatch => {
    dispatch(fetchLeadRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await leadService.postHome(json);
      if (data.error) {
        dispatch(actionsModalError.openModalError());
      } else {
        dispatch(fetchLeadSuccess(data.data[0]));
      }
    } catch (error) {
      console.log(`Error fetch LeadHome action: ${error}`)
      dispatch(actionsModalError.openModalError());
      dispatch(fetchLeadFailure());
    }
  }
};
